//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { RIGHTS_SKIPPED_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { createAction } from '@utils/actions';

const openRightsSkippedModal = () => {
  return createAction({
    type: RIGHTS_SKIPPED_MODAL_ACTIONS.OPEN_MODAL,
  });
};

const closeRightsSkippedModal = () => {
  return createAction({
    type: RIGHTS_SKIPPED_MODAL_ACTIONS.CLOSE_MODAL,
  });
};

export type RightsSkippedModalAction = ReturnType<
  typeof openRightsSkippedModal | typeof closeRightsSkippedModal
>;

export const rightsSkippedModalActions = {
  openRightsSkippedModal,
  closeRightsSkippedModal,
};
